module.exports = __webpack_public_path__ + "static/media/pending.9b79f9c8.svg";